<template>
  <div class="editor-autocomplete-container">
    <div class="editor-autocomplete-label">{{ cvDetail.submodule_info.skill_title }}</div>
    <el-autocomplete
      class="select-input-auto-main"
      v-model="extras.skill.description"
      :debounce="10"
      hide-loading
      label="skill"
      value-key="name"
      :fetch-suggestions="remoteMethod"
      @select="select"
      select-when-unmatched
      type="textarea"
      :autosize="{ minRows: 1, maxRows: 500 }"
      resize="none"
      popper-class="editor-autocomplete-popper"
      v-on="$listeners"
      v-bind="$attrs"
    >
      <template slot-scope="{ item }">
        <p v-html="item.highlight"></p>
      </template>
    </el-autocomplete>
  </div>
</template>
<script>
import api from '@/api';
import { mapState } from 'vuex';

export default {
  props: {
    separator: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      run: null,
      cacheValue: null, // 缓存输入的值
      options: [],
      value: {
        name: '',
      },
      list: [],
      loading: false,
    };
  },
  computed: {
    ...mapState('editor', ['extras', 'cvDetail']),
  },
  methods: {
    async remoteMethod(val, cb) {
      if (!val) return cb([]);
      this.cacheValue = val;
      let index = val.lastIndexOf(this.separator);
      let query = val.slice(index + 1);
      if (!query) return cb([]);
      let params = {
        keyword: query,
      };
      try {
        let res = await api.cvsEditor.skillAutoCompletions(params);
        if (res.code === 1000) {
          cb && cb(res.data || []);
        }
      } catch (e) {
        console.log('skillAutoCompletions error:', e);
      }
    },
    select(data) {
      if (!data.name) return;
      let index = this.cacheValue.lastIndexOf(this.separator);
      let str = this.cacheValue.slice(0, index + 1) + data.name + this.separator;
      this.extras.skill.description = str;
      this.cacheValue = str;
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/assets/css/variable.scss';
.editor-autocomplete-container {
  display: flex;
  flex-direction: column;
  .editor-autocomplete-label {
    font-size: 14px;
    color: $form-label-color;
    margin-bottom: 12px;
  }
  .el-autocomplete {
    ::v-deep(.el-input),
    ::v-deep(.el-textarea) {
      .el-input__inner,
      .el-textarea__inner {
        border-color: transparent !important;
        background-color: $page-bg-sub-color;
        color: $text-color;
        &:focus,
        &:hover {
          border-color: transparent;
        }
        &::placeholder {
          color: $placeholder-color;
        }
      }
    }
  }
}
</style>
<style lang="scss">
@import '@/assets/css/variable.scss';
.editor-autocomplete-popper {
  position: absolute;
  z-index: 10;
  background-color: transparent !important;
  border-color: $select-border-color !important;
  background: linear-gradient(45deg, $select-bg-start-color 0%, $select-bg-middle-color 62%, $select-bg-end-color 100%);
  .el-scrollbar {
    .el-autocomplete-suggestion__wrap {
      .el-autocomplete-suggestion__list {
        li {
          color: $text-color;
          .es-highlighter {
            color: $theme-color;
          }
          &.hover,
          &:hover {
            background-color: $select-dropdown-item-hover;
          }
        }
      }
    }
  }
  .popper__arrow {
    display: none;
  }
}
</style>
